import { InputTypes, ValueTypes, IFieldDefinition, FieldViews } from 'app/interfaces';
import { filesystemsFieldsMap } from './fields';
import { Validators } from '@angular/forms';
import * as moment from 'moment';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

filesystemsFieldsMap.forEach(function(value, key, map): void{
	value = Object.assign({}, value, { key: value.key });
	fieldsMap.set(key, value);
});

fieldsMap.set('scenario', {
	key: 'scenario',
	name: '',
	inputType: InputTypes.HIDDEN,
	valueType: ValueTypes.STRING,
	fieldView: FieldViews.HIDDEN,
	formValidators: [ Validators.required ],
	defaultValue(dataContainerService: IDataContainerService) {
		return 'filesystems.pratiche_server';
	}
});

export {fieldsMap as fieldsMapPraticheServer};
